import { FormattedMessage } from 'react-intl'

import { CurrencyDollarIcon, StarIcon } from '@gto/ui/icons/solid'

import type { FlipOutRow } from '@/pages/promotion/hooks/use-flip-out-prizes-table-cols'
import { useUserPromoStatus } from '@/pages/promotion/hooks/use-user-promo-status'
import { safeNumber } from '@/utils/helpers'

import { FlipOutPrizesTable } from './flip-out-prizes-table'
import { FlipOutProgress } from './flip-out-progress'
import { FlipOutSectionTitle } from './flip-out-section-title'

export const FlipOutsSection = () => {
  const { userRake, flipOut1, flipOut2, loading } = useUserPromoStatus()

  return (
    <section className="flex gap-4 sm:flex-col">
      <div className="flex min-w-0 flex-[1_0_48%] flex-col gap-6">
        <FlipOutSectionTitle
          description={<FormattedMessage id="promo.allInFlipOuts.1.description" />}
          icon={CurrencyDollarIcon}
          title={<FormattedMessage id="promo.allInFlipOuts.1.title" />}
        />
        <FlipOutProgress
          completed={flipOut1?.eligible}
          current={safeNumber(userRake)}
          loading={loading}
          total={safeNumber(flipOut1?.required_score)}
        />
        <FlipOutPrizesTable rows={firstFlipOutData} />
      </div>
      <div className="flex min-w-0 flex-[1_0_48%] flex-col gap-6">
        <FlipOutSectionTitle
          description={<FormattedMessage id="promo.allInFlipOuts.2.description" />}
          icon={StarIcon}
          title={<FormattedMessage id="promo.allInFlipOuts.2.title" />}
        />
        <FlipOutProgress
          completed={flipOut2?.eligible}
          current={safeNumber(userRake)}
          loading={loading}
          total={safeNumber(flipOut2?.required_score)}
        />
        <FlipOutPrizesTable rows={secondFlipOutData} />
      </div>
    </section>
  )
}

const firstFlipOutData: FlipOutRow[] = [
  {
    id: '1',
    prize: 'promo.rakeRace.prize3',
    prizesCount: 5,
    prizeValue: 828,
    totalValue: 4140,
  },
  {
    id: '2',
    prize: 'promo.rakeRace.prize4',
    prizesCount: 21,
    prizeValue: 149,
    totalValue: 3129,
  },
  {
    id: '3',
    prize: 'promo.rakeRace.prize5',
    prizesCount: 20,
    prizeValue: 89,
    totalValue: 1780,
  },
  {
    id: '4',
    prize: 'promo.rakeRace.prize6',
    prizesCount: 20,
    prizeValue: 49,
    totalValue: 980,
  },
]

const secondFlipOutData: FlipOutRow[] = [
  {
    id: '1',
    prize: 'promo.rakeRace.prize2',
    prizesCount: 5,
    prizeValue: 1548,
    totalValue: 7740,
  },
  {
    id: '2',
    prize: 'promo.rakeRace.prize4',
    prizesCount: 10,
    prizeValue: 149,
    totalValue: 1490,
  },
  {
    id: '3',
    prize: 'promo.rakeRace.prize5',
    prizesCount: 10,
    prizeValue: 89,
    totalValue: 890,
  },
]
